import { render, staticRenderFns } from "./StickyPlayer.vue?vue&type=template&id=3c353df7&scoped=true&"
import script from "./StickyPlayer.vue?vue&type=script&lang=ts&"
export * from "./StickyPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./StickyPlayer.vue?vue&type=style&index=0&id=3c353df7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c353df7",
  null
  
)

export default component.exports